module.exports = __webpack_public_path__ + "static/media/seglogic-shopify.bf321b84.png";